import React, { type Ref } from 'react';

import { useIntl } from 'react-intl-next';

import ClockIcon from '@atlaskit/icon/core/clock';
import {
	FlyoutMenuItem,
	FlyoutMenuItemContent,
	type FlyoutMenuItemProps,
	FlyoutMenuItemTrigger,
} from '@atlaskit/navigation-system/side-nav-items/flyout-menu-item';

import { GlobalRecentMenuContent } from './menu-content';
import { messages } from './messages';

export type GlobalRecentMenuItemProps = {
	onOpenChange?: FlyoutMenuItemProps['onOpenChange'];
	isDefaultOpen?: FlyoutMenuItemProps['isDefaultOpen'];
	triggerRef?: Ref<HTMLButtonElement>;
};

export const withGlobalRecentMenuItem =
	(Content: React.FunctionComponent) =>
	({ onOpenChange, isDefaultOpen, triggerRef }: GlobalRecentMenuItemProps) => {
		const { formatMessage } = useIntl();

		return (
			<FlyoutMenuItem onOpenChange={onOpenChange} isDefaultOpen={isDefaultOpen}>
				<FlyoutMenuItemTrigger
					ref={triggerRef}
					elemBefore={<ClockIcon label="" color="currentColor" />}
				>
					{formatMessage(messages.flyoutMenuItemTriggerTitle)}
				</FlyoutMenuItemTrigger>
				<FlyoutMenuItemContent>
					<Content />
				</FlyoutMenuItemContent>
			</FlyoutMenuItem>
		);
	};

export const GlobalRecentMenuItem = withGlobalRecentMenuItem(GlobalRecentMenuContent);

// This is only needed to support the Atlaskit docs. See https://hello.atlassian.net/wiki/spaces/navx/pages/5305993008/Platform+Guide#Atlaskit-%3CProps%3E-component-not-rendering
export default (props: GlobalRecentMenuItemProps) => {
	throw new Error('This default export is only used for Atlaskit documentation. Do not use!');
};
